import { TRANSACTION_TYPE_PAL } from 'consts';

const usePayALoanTransaction = (transactionType) => {
  return transactionType?.substring(0, 3) === TRANSACTION_TYPE_PAL;
};
export default usePayALoanTransaction;
